// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NrJFr","placeholdersHeader":"styles_placeholdersHeader__10rs8","editorStyle":"styles_editorStyle__1p0jH","placeholdersBox":"styles_placeholdersBox__WosAL"};